{
  "id": "zuffenhausen",
  "makes": ["Porsche"],
  "mainGroups": "vw_group",
  "sources": "Porsche type numbers as the community uses them, compiled in October 2026 from Wikipedia's Porsche model and generation pages (911, 911 Turbo, GT3 and GT2, Boxster and Cayman, Cayenne, Panamera, Macan, Taycan) and Porsche's newsroom on type numbers. A facelift phase is a sub-code of its generation (\"997.2\" of \"997\"): parts marked for the generation fit both phases. A variant whose parts don't interchange with the base car carries its model in brackets (\"996 (Turbo)\", \"997 (GT3)\"); the 930 is the Turbo of the G-model and keeps its own number. Cayenne generations are named by their type numbers (955, 957, 958, 9YA), never E1–E3, which are BMW codes.",
  "chassisCodeLists": [
    {
      "id": "porsche",
      "aliases": false,
      "entries": [
        { "code": "356", "model": { "en": "356", "de": "356" }, "from": 1948, "to": 1965 },
        {
          "code": "901",
          "model": { "en": "911 (original, F-model)", "de": "911 (Urmodell, F-Modell)" },
          "from": 1964,
          "to": 1973
        },
        { "code": "912", "model": { "en": "912", "de": "912" }, "from": 1965, "to": 1969 },
        { "code": "914", "model": { "en": "914", "de": "914" }, "from": 1969, "to": 1976 },
        {
          "code": "911 G",
          "model": { "en": "911 G-model", "de": "911 G-Modell" },
          "from": 1973,
          "to": 1989
        },
        {
          "code": "930",
          "model": { "en": "911 Turbo (930)", "de": "911 Turbo (930)" },
          "from": 1975,
          "to": 1989
        },
        { "code": "924", "model": { "en": "924", "de": "924" }, "from": 1976, "to": 1988 },
        { "code": "928", "model": { "en": "928", "de": "928" }, "from": 1977, "to": 1995 },
        { "code": "944", "model": { "en": "944", "de": "944" }, "from": 1982, "to": 1991 },
        { "code": "959", "model": { "en": "959", "de": "959" }, "from": 1986, "to": 1988 },
        { "code": "964", "model": { "en": "911", "de": "911" }, "from": 1989, "to": 1994 },
        {
          "code": "964 (Turbo)",
          "model": { "en": "911 Turbo", "de": "911 Turbo" },
          "from": 1990,
          "to": 1994
        },
        { "code": "968", "model": { "en": "968", "de": "968" }, "from": 1992, "to": 1995 },
        { "code": "993", "model": { "en": "911", "de": "911" }, "from": 1994, "to": 1998 },
        {
          "code": "993 (Turbo)",
          "model": { "en": "911 Turbo", "de": "911 Turbo" },
          "from": 1995,
          "to": 1998
        },
        {
          "code": "993 (GT2)",
          "model": { "en": "911 GT2", "de": "911 GT2" },
          "from": 1995,
          "to": 1998
        },
        { "code": "986", "model": { "en": "Boxster", "de": "Boxster" }, "from": 1996, "to": 2004 },
        {
          "code": "996",
          "model": { "en": "911 (all phases)", "de": "911 (alle Phasen)" },
          "from": 1998,
          "to": 2005
        },
        {
          "code": "996.1",
          "model": { "en": "911 (phase 1)", "de": "911 (Phase 1)" },
          "from": 1998,
          "to": 2001,
          "parent": "996"
        },
        {
          "code": "996.2",
          "model": { "en": "911 (phase 2, facelift)", "de": "911 (Phase 2, Facelift)" },
          "from": 2002,
          "to": 2005,
          "parent": "996"
        },
        {
          "code": "996 (Turbo)",
          "model": { "en": "911 Turbo", "de": "911 Turbo" },
          "from": 2001,
          "to": 2005
        },
        {
          "code": "996 (GT3)",
          "model": { "en": "911 GT3", "de": "911 GT3" },
          "from": 1999,
          "to": 2005
        },
        {
          "code": "996 (GT2)",
          "model": { "en": "911 GT2", "de": "911 GT2" },
          "from": 2001,
          "to": 2005
        },
        { "code": "955", "model": { "en": "Cayenne", "de": "Cayenne" }, "from": 2002, "to": 2006 },
        {
          "code": "980",
          "model": { "en": "Carrera GT", "de": "Carrera GT" },
          "from": 2003,
          "to": 2006
        },
        {
          "code": "997",
          "model": { "en": "911 (all phases)", "de": "911 (alle Phasen)" },
          "from": 2004,
          "to": 2012
        },
        {
          "code": "997.1",
          "model": { "en": "911 (phase 1)", "de": "911 (Phase 1)" },
          "from": 2004,
          "to": 2008,
          "parent": "997"
        },
        {
          "code": "997.2",
          "model": { "en": "911 (phase 2, facelift)", "de": "911 (Phase 2, Facelift)" },
          "from": 2008,
          "to": 2012,
          "parent": "997"
        },
        {
          "code": "997 (Turbo)",
          "model": { "en": "911 Turbo", "de": "911 Turbo" },
          "from": 2006,
          "to": 2012
        },
        {
          "code": "997 (GT3)",
          "model": { "en": "911 GT3", "de": "911 GT3" },
          "from": 2006,
          "to": 2011
        },
        {
          "code": "997 (GT2)",
          "model": { "en": "911 GT2", "de": "911 GT2" },
          "from": 2007,
          "to": 2012
        },
        {
          "code": "987",
          "model": { "en": "Boxster, Cayman (all phases)", "de": "Boxster, Cayman (alle Phasen)" },
          "from": 2005,
          "to": 2012
        },
        {
          "code": "987.1",
          "model": { "en": "Boxster, Cayman (phase 1)", "de": "Boxster, Cayman (Phase 1)" },
          "from": 2005,
          "to": 2008,
          "parent": "987"
        },
        {
          "code": "987.2",
          "model": {
            "en": "Boxster, Cayman (phase 2, facelift)",
            "de": "Boxster, Cayman (Phase 2, Facelift)"
          },
          "from": 2009,
          "to": 2012,
          "parent": "987"
        },
        {
          "code": "957",
          "model": { "en": "Cayenne (facelift)", "de": "Cayenne (Facelift)" },
          "from": 2007,
          "to": 2010
        },
        {
          "code": "970",
          "model": { "en": "Panamera (all phases)", "de": "Panamera (alle Phasen)" },
          "from": 2009,
          "to": 2016
        },
        {
          "code": "970.1",
          "model": { "en": "Panamera (phase 1)", "de": "Panamera (Phase 1)" },
          "from": 2009,
          "to": 2013,
          "parent": "970"
        },
        {
          "code": "970.2",
          "model": { "en": "Panamera (phase 2, facelift)", "de": "Panamera (Phase 2, Facelift)" },
          "from": 2013,
          "to": 2016,
          "parent": "970"
        },
        {
          "code": "958",
          "model": { "en": "Cayenne (all phases)", "de": "Cayenne (alle Phasen)" },
          "from": 2010,
          "to": 2017
        },
        {
          "code": "958.1",
          "model": { "en": "Cayenne (phase 1)", "de": "Cayenne (Phase 1)" },
          "from": 2010,
          "to": 2014,
          "parent": "958"
        },
        {
          "code": "958.2",
          "model": { "en": "Cayenne (phase 2, facelift)", "de": "Cayenne (Phase 2, Facelift)" },
          "from": 2014,
          "to": 2017,
          "parent": "958"
        },
        {
          "code": "991",
          "model": { "en": "911 (all phases)", "de": "911 (alle Phasen)" },
          "from": 2011,
          "to": 2019
        },
        {
          "code": "991.1",
          "model": { "en": "911 (phase 1)", "de": "911 (Phase 1)" },
          "from": 2011,
          "to": 2015,
          "parent": "991"
        },
        {
          "code": "991.2",
          "model": { "en": "911 (phase 2, facelift)", "de": "911 (Phase 2, Facelift)" },
          "from": 2016,
          "to": 2019,
          "parent": "991"
        },
        {
          "code": "991 (Turbo)",
          "model": { "en": "911 Turbo", "de": "911 Turbo" },
          "from": 2013,
          "to": 2019
        },
        {
          "code": "991 (GT3)",
          "model": { "en": "911 GT3", "de": "911 GT3" },
          "from": 2013,
          "to": 2019
        },
        {
          "code": "991 (GT2)",
          "model": { "en": "911 GT2 RS", "de": "911 GT2 RS" },
          "from": 2017,
          "to": 2019
        },
        {
          "code": "981",
          "model": { "en": "Boxster, Cayman", "de": "Boxster, Cayman" },
          "from": 2012,
          "to": 2016
        },
        {
          "code": "918",
          "model": { "en": "918 Spyder", "de": "918 Spyder" },
          "from": 2013,
          "to": 2015
        },
        { "code": "95B", "model": { "en": "Macan", "de": "Macan" }, "from": 2014, "to": 2026 },
        {
          "code": "982",
          "model": { "en": "718 Boxster, 718 Cayman", "de": "718 Boxster, 718 Cayman" },
          "from": 2016,
          "to": 2025
        },
        {
          "code": "971",
          "model": { "en": "Panamera (all phases)", "de": "Panamera (alle Phasen)" },
          "from": 2016,
          "to": 2024
        },
        {
          "code": "971.1",
          "model": { "en": "Panamera (phase 1)", "de": "Panamera (Phase 1)" },
          "from": 2016,
          "to": 2020,
          "parent": "971"
        },
        {
          "code": "971.2",
          "model": { "en": "Panamera (phase 2, facelift)", "de": "Panamera (Phase 2, Facelift)" },
          "from": 2020,
          "to": 2024,
          "parent": "971"
        },
        { "code": "9YA", "model": { "en": "Cayenne", "de": "Cayenne" }, "from": 2017, "to": null },
        {
          "code": "992",
          "model": { "en": "911 (all phases)", "de": "911 (alle Phasen)" },
          "from": 2019,
          "to": null
        },
        {
          "code": "992.1",
          "model": { "en": "911 (phase 1)", "de": "911 (Phase 1)" },
          "from": 2019,
          "to": 2024,
          "parent": "992"
        },
        {
          "code": "992.2",
          "model": { "en": "911 (phase 2, facelift)", "de": "911 (Phase 2, Facelift)" },
          "from": 2024,
          "to": null,
          "parent": "992"
        },
        {
          "code": "992 (Turbo)",
          "model": { "en": "911 Turbo", "de": "911 Turbo" },
          "from": 2020,
          "to": null
        },
        {
          "code": "992 (GT3)",
          "model": { "en": "911 GT3", "de": "911 GT3" },
          "from": 2021,
          "to": null
        },
        { "code": "9J1", "model": { "en": "Taycan", "de": "Taycan" }, "from": 2019, "to": null },
        {
          "code": "XAB",
          "model": { "en": "Macan Electric", "de": "Macan Electric" },
          "from": 2024,
          "to": null
        },
        {
          "code": "976",
          "model": { "en": "Panamera", "de": "Panamera" },
          "from": 2024,
          "to": null
        },
        {
          "code": "X1A",
          "model": { "en": "Cayenne Electric", "de": "Cayenne Electric" },
          "from": 2026,
          "to": null
        }
      ]
    }
  ]
}
